export default "__VITE_ASSET__6583dfdc__"